<template>
    <g>
        <path :style="{ fill: color }" d="M875.3,500.9c1.2-7.5-3.7-17.4-3.4-25.1c0.2-7.7,3.3-15.5,6.3-21c3-5.4,5.6-7,7.8-8.1
	c1.6-0.8,3.6-1.4,5.3-1.8c0,0,0,0,0,0c2-0.5,3.6-0.6,3.6-0.6s3.2-4.1,7.6-4.5c4.4-0.4,12.9,4.6,17.9,11.5c5,6.9,9,14,9.6,20.7
	c0.6,6.7-3.7,18.5-3.7,25.2s6.1,9.5,8.1,14.7c1.7,4.4,1.4,8,1.2,8.9c-4.3-2.5-9.3-4.3-13-5.5c-2.5-0.8-4.5-1.5-5.5-1.8
	c-0.4-0.2-0.7-0.2-0.7-0.2l-3.3-1.1c-0.8-0.3-1.3-1-1.3-1.9v-5.8c2.5-2.7,4.5-5.7,5.8-8.1c0.8-1.7,1.5-4.1,2-7
	c0.3,0.3,0.7,0.5,1.1,0.5c1.7,0,2.3-1.8,3.4-4.1c1.1-2.3,2.3-5.1,1.6-6.7c-1-2.6-3.1-2.4-4.6-1.5c-0.8,2.5-1.7,4.3-1.7,4.3
	c0-1.4,0.4-7,0-10.6c-0.4-3.7-4.6-6.6-7.6-7s-5.3,0.5-9.7-0.1c-4.3-0.6-8.6-5-10.1-5.2c-1.5-0.2-8.6,4.8-10.1,8.9
	c-1.6,4.1-1.9,14.6-1.9,14.6s-0.6-2.2-1.3-5.1c-1.5-0.6-3.2-0.5-4.1,1.8c-0.6,1.7,0.5,4.4,1.6,6.7c1.1,2.3,1.7,4.1,3.4,4.1
	c0.3,0,0.5-0.1,0.7-0.2c0.3,2,0.7,3.7,1,5c0.2,0.7,0.5,1.5,0.9,2.3c0,0,0,0,0,0.1c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.1,0.1,0.2
	c0.1,0.2,0.2,0.3,0.3,0.5c0,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.2,0.3,0.3,0.5c0,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.2,0.3,0.3,0.5
	c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.2,0.2,0.3
	c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.3,0.4
	c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.4,0.4c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.3,0.3,0.4,0.4c0.1,0.1,0.2,0.2,0.2,0.3
	c0,0,0.1,0.1,0.1,0.1v5.5c0,0.8-0.5,1.6-1.3,1.9l-3.3,1.1c0,0-0.3,0.1-0.7,0.2c-1,0.3-3,1-5.5,1.8c-3.3,1.1-7.4,2.5-11.3,4.5
	C866.8,512.6,874.4,506.9,875.3,500.9z"/>
        <path :style="{ fill: color }" d="M75.8,29c-0.4-9.9-5.9-15.1-11.3-17.9c0-0.2,0.1-0.3,0.1-0.5c0-1.5-1.5-2.8-3.8-3.8
	c0.3-0.4,0.5-0.8,0.5-1.3c0-2-3.6-3.6-8.1-3.6s-8.1,1.6-8.1,3.6c0,0.5,0.2,0.9,0.5,1.3c-2.3,0.9-3.8,2.3-3.8,3.8
	c0,0.4,0.1,0.9,0.4,1.3c-0.2,0.1-0.3,0.2-0.5,0.3c-4.4,2.9-8.9,7.5-9.2,16c-0.2,5.9,0,11.7,1.1,16l0.1,0c0.2-2.8,0.1-9,1.1-11.4
	c1.1-2.6,3.9-5.8,5.4-8.1c2.1-3.2,3.1-5.7,2.6-8.7c0.1,0.4,0.1,0.7,0.1,1c0.1,1.1,0,1.9,0.5,3c2.2,4.5,9.5,5.2,14.1,6.3
	c5.4,1.3,12.1,4.2,15.2,9.5c1.4,2.4,1.5,6.3,1.5,9.4C75.9,38,76,35.4,75.8,29z"/>
    </g>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair19',
        mixins: [Hair],
    }
</script>

